import { Injectable } from '@angular/core';
import { ContentService } from '../content/content.service'
import { ProfileService } from '../profile/profile.service'
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';


import { version as pkgVersionString, fullname as pkgFullName } from 'package.json';

@Injectable({
  providedIn: 'root'
})
export class LocalContentService {

  private staticContent = new BehaviorSubject<any>({ lastchange: 0 });
  private lastFullContent: any = { lastchange: 0 };
  private langCode = 'ENG';

  public pageDisplayRequest=new Subject();

  constructor(private contentService: ContentService, private profileService: ProfileService,
    private router: Router) {
    profileService.getLanguageCode().subscribe((code) => {
      if (this.langCode == code) return; //no change really
      this.langCode = code;
      this.clearCaches(); //clear rthe generated cache for the new language
      this.doTranslate();
    });
    contentService.getStaticContent().subscribe((data) => {
      this.lastFullContent = data;
      this.doTranslate();
    });
  }

  public requestPageDisplay(pageRef:string)
  {
    let p=this.staticContent.value.pages[pageRef];
    if (!p) return;
    if (p.subpages)
      this.pageDisplayRequest.next(pageRef);
    else
      this.router.navigate(['/content', pageRef])
  }

  public getStaticContent(): Observable<any> {
    return this.staticContent;
  }

  public getPage(pr: string): Observable<any> {
    return this.staticContent.pipe(map(
      (content) => content.pages?content.pages[pr]:null
    ));
  }

  private doTranslate() {
    //first make a deep copy
    let trans = JSON.parse(JSON.stringify(this.lastFullContent));

    const translateNode = (node) => {
      Object.keys(node).forEach((key) => {
        let o = node[key];
        if (!(o instanceof Object)) return; //no depth here so leave it
        if (("__LANG__ENG" in o)) { //this is a translatable bit
          let lcode = this.langCode;
          let fallback=false;
          let localVersion = o["__LANG__" + this.langCode];
          if (!localVersion) {//not available use english fallback
            localVersion = o["__LANG__ENG"];
            lcode = "ENG";
            fallback=true;
          }
          if (localVersion instanceof Object) {//if local version is an object add its language to it
            localVersion["__LANG__"] = lcode;
            if (fallback) localVersion["__LANGFALLBACK__"] = this.langCode;
          }
          node[key] = localVersion
        } else { //maybe it has translatable bits
          translateNode(o);
        }
      })
    }

    translateNode(trans);
    this.processTree(trans);
    this.staticContent.next(trans);
  }

  /* this is to extract useful information into the pages such a
     the name of the top level section page and whether it is a 'group' page
  */
  public processTree(data) {
    if (!data.pages) return; //just a blank tree atm
    const setSectionTitle=(pageref,title,icon) => {
      const page=data.pages[pageref];
      if ((!page)||(!page.content)) return;
      page.pageRef=pageref;
      if (title) page.content.sectionTitle=title;
      if (icon) page.sectionIcon=icon; else page.sectionIcon=page.icon;
      page.content.title=this.substituteSystemValues(page.content.title);
      if ((!page.subpages)||(!page.subpages.length)) return;
      let sectionTitle=title?title:page.content.title;
      let sectionIcon=icon?icon:page.icon;
      page.subpages.split(' ').forEach((n)=>setSectionTitle(n,sectionTitle,sectionIcon))
    }
    setSectionTitle('HOME',null,null)
    setSectionTitle('ABOUT',pkgFullName,null)
  }

  private substituteSystemValues(val)
  {
    if (!val) return val; //don;t try this on a non srting
    return val.replace(/~~version~~/g, pkgVersionString);
  }

  public getStaticResource(pageRef: string, imageIndex = -1) {
    //work directly off static content
    let page = this.staticContent.getValue().pages[pageRef];
    let langcode = page.content.__LANG__;
    if (page.content.hasContent==false) langcode="ENG";//still fall back - no content
    return this.contentService.getStaticResource(pageRef, langcode, imageIndex)
  }


  private URLCache = {

  };

  public getURLCache(pageRef, index) {
    let k = pageRef + index;
    return this.URLCache[k];
  }

  public setURLCache(pageRef, index, url) {
    let k = pageRef + index;
    this.URLCache[k] = url;
  }

  public clearCaches() {
    this.URLCache = {};
    this.contentService.clearCaches();
  }

  public getMediaType(pageRef: string, imageIndex: number)
  {
    let page = this.staticContent.getValue().pages[pageRef];
    let langCode = page.content.__LANG__;
    return this.contentService.getMediaType(pageRef,langCode,imageIndex);
  }

  public getMediaStreamURL(pageRef: string, imageIndex: number)
  {
    let page = this.staticContent.getValue().pages[pageRef];
    let langCode = page.content.__LANG__;
    return this.contentService.getMediaStreamURL(pageRef,langCode,imageIndex);
  }

  public getStaticResourceAsURL(pageRef: string, imageIndex = -1) {
    let pre = this.getURLCache(pageRef, imageIndex);
    if (pre) { //just return the cache now
      return new Observable((observer) => {
        observer.next(pre);
        observer.complete();
      });
    }
    return this.getStaticResource(pageRef, imageIndex).
      pipe(switchMap((res: any) => {
        return new Observable((observer) => {
          let blob: any = res.body;
          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            var base64data = reader.result;
            this.setURLCache(pageRef, imageIndex, base64data);
            observer.next(base64data);
            observer.complete();
          }
        })
      }));
  }


}
